__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/aae1abc/_next/";